import { PolicyInputRow, PolicyRow } from "namirasoft-access";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccessEntities } from "../AccessEntities";
import { AccessLayout } from "../AccessLayout";
import { AccessProps } from "../AccessProps";

interface PolicyPageProps extends NSARouterMakerResult, AccessProps { }

function PolicyListPage(props: PolicyPageProps)
{
	return (
		<AccessLayout<PolicyRow, PolicyInputRow> {...props}
			action={{
				title: "",
				description: "A list of custom permission policies tailored to your needs.",
				menus: {}
			}}
			pages={{
				entity: AccessEntities.policy(props),
				list: {
					ui: {}
				}
			}}
		>
			<></>
		</AccessLayout>
	);
}

export default PolicyListPage;